<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.ip_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ip_vendname">
            <label class="weui-form-preview__label">{{customLabel.ip_vendname || "供应商"}}</label>
            <em class="weui-form-preview__value">{{ form.main.ip_vendname }}</em>
          </div>
          <div class="weui-form-preview__item" slot="ip_contact">
            <label class="weui-form-preview__label">{{customLabel.ip_contact || "联系人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              {{ form.main.ip_contact }}
              {{ form.main.ip_tel }}
              <call-mobile :mobile="form.main.ip_tel"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ip_successdate">
            <label class="weui-form-preview__label">{{customLabel.ip_successdate || "生效日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ip_successdate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ip_faildate">
            <label class="weui-form-preview__label">{{customLabel.ip_faildate || "截止日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ip_faildate
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.ipd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料"}}</label>
            <span class="weui-form-preview__value">
              {{ item.productDTO.pr_detail }}
              {{ item.productDTO.pr_code }}
            </span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO.pr_orispeccode" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">
              {{ item.productDTO.pr_orispeccode }}
            </span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO.pr_spec" slot="pr_spec">
            <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
            <span class="weui-form-preview__value">
              {{ item.productDTO.pr_spec }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ipd_lapqty">
            <label class="weui-form-preview__label">{{customLabel.ipd_lapqty || "数量"}}</label>
            <span class="weui-form-preview__value">
              {{ item.ipd_lapqty }}
              {{ item.productDTO.pr_unit }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ipd_price">
            <label class="weui-form-preview__label">{{customLabel.ipd_price || "单价"}}</label>
            <span class="weui-form-preview__value">
              {{ "￥" + item.ipd_price }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pr_brand">
            <label class="weui-form-preview__label">{{customLabel.pr_brand || "厂家/品牌"}}</label>
            <span class="weui-form-preview__value">
              {{ item.productDTO.pr_brand }}
            </span>
          </div>
           </custom-layout>
        </div>
      </div>
      <file-list v-model="form.main.ip_attach" />
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile,
  },
  data() {
    return {
      baseUrl: "/api/sample/inquiryprice",
      codeField: "ip_code",
      statusField: "ip_statuscode",
      caller: "Purchase",
      xtype:'sample-inquiryprice-formpanel'
    };
  },
}
</script>